export default {
    userManagement: 'จัดการผู้ใช้',
    searchByUserName: 'ค้นหาด้วยชื่อผู้ใช้งาน',
    search: 'ค้นหา',
    createNewMember: 'สร้างสมาชิกใหม่',
    userName: 'ชื่อผู้ใช้งาน',
    branch: 'สาขา',
    role: 'ตำแหน่ง',
    joinedAt: 'วันที่เข้าร่วม',
    contactNo: 'เบอร์โทรติดต่อ',
    action: 'แก้ไข',
    congratulation: 'ยินดีด้วย',
    userIsDeleted: 'ผู้ใช้งานถูกลบแล้ว',
    deleteUser: 'ลบผู้ใช้งาน',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบผู้ใช้งาน'
}
